module.exports = __webpack_public_path__ + "img/legs_line_level_1.041017ad.svg";